import type { AppContextEntry } from '../../chat-app-context'
import { describeEntity } from '../../chat-app-context'
import type { ExplorerView } from './DashboardsHomePage'
import type { EditorMode } from './editor/editor-mode'

export interface DashboardsAppContextInput {
  view: ExplorerView
  /** Loaded row for the open dashboard/template path, when one is open. */
  item?: { name: string; path: string; id: string }
  /** Only set while an item is open — the editor is unmounted otherwise. */
  editorMode?: EditorMode
  /** Selected folder path; mutually exclusive with an open item. */
  folder?: string
}

/**
 * The URL carries owner + path; the page has the row, so it offers
 * `name + path + id` instead and supersedes the raw route params.
 */
export function buildDashboardsAppContextEntries(
  input: DashboardsAppContextInput
): AppContextEntry[] {
  const entries: AppContextEntry[] = [{ key: 'View', value: input.view }]

  if (input.item !== undefined) {
    entries.push({
      key: input.view === 'templates' ? 'Open template' : 'Open dashboard',
      value: describeEntity({
        name: input.item.name,
        fields: [['path', input.item.path]],
        id: input.item.id
      })
    })
    if (input.editorMode !== undefined) {
      entries.push({ key: 'Editor mode', value: input.editorMode })
    }
  }

  if (input.folder !== undefined && input.folder !== '') {
    entries.push({ key: 'Folder', value: input.folder })
  }

  return entries
}

/**
 * Baseline path/search params the entries above stand in for.
 * `*` is the resource-path splat from `/dashboards/…` route matches.
 */
export const DASHBOARDS_SUPERSEDED_PARAMS = [
  'view',
  'folder',
  'dashboard',
  'template',
  'agent',
  'selected',
  'run',
  '*'
]
